export default "__VITE_ASSET__EyViJguO__"